import * as api from '../../api/api-modal-gastos-honorarios';
import { 
    GET_CONFIG_FORM22,
    GET_COMBO_TIPO_GASTO,
    GET_COMBO_COBERTURA,
    GET_COMBO_MONEDAS,
    GET_GRILLA_HISTORIAL_GASTOS,
    POST_ACTUALIZAR_TIPO_GASTO,
    POST_ANULAR,
    SET_LOADING_GASTOS,
    LIMPIAR_REF,
    GET_MONTOS
    
} from '../types';

export const configuracionFormAction22 = (query) => ({
    type: GET_CONFIG_FORM22,
    payload: api.getConfiguracionForm22(query)
});
export const obtenerComboTipoGasto = (query) => ({
    type: GET_COMBO_TIPO_GASTO,
    payload: api.getComboTipoGasto(query)
});
export const obtenerComboCobertura = (query) => ({
    type: GET_COMBO_COBERTURA,
    payload: api.getComboCobertura(query)
});
export const obtenerComboMonedas = (query) => ({
    type: GET_COMBO_MONEDAS,
    payload: api.getComboMonedas(query)
});
export const obtenerGrillaHistorialGastos = (query) => ({
    type: GET_GRILLA_HISTORIAL_GASTOS,
    payload: api.getGrillaHistorialGastos(query)
});
export const postActualizarTipoGastoJudicial = (gastos) => ({
    type: POST_ACTUALIZAR_TIPO_GASTO,
    payload: api.actualizarTipoGastos(gastos)
});
export const postAnularGato = (gastos) => ({
    type: POST_ANULAR,
    payload: api.postAnular(gastos)
});
export const cambiarLoadingGastos = (loading) => ({
    type: SET_LOADING_GASTOS,
    payload: loading
});
export const limpiarRefAction = (limp) => ({
    type: LIMPIAR_REF,
    payload: limp
});
export const obtenerMontos= (query) => ({
    type: GET_MONTOS,
    payload: api.getMontosInformados(query)
});